import type { ReactNode } from "react";
import { useTranslations } from "use-intl";

import { MobileStepper } from "@/components/MobileStepper/MobileStepper";

type Props = {
  totalSteps: number;
  currentStepNumber: number;
  currentStepTitle?: ReactNode;
};

export const ProgressStepper = ({
  totalSteps,
  currentStepNumber,
  currentStepTitle,
}: Props) => {
  const t = useTranslations();

  return (
    <div>
      <MobileStepper
        variant="progress"
        steps={totalSteps}
        position="static"
        activeStep={currentStepNumber}
      />

      <div className="flex w-full items-center gap-2">
        <span className="text-sm text-text-secondary">
          {t("step", { currentStep: currentStepNumber, totalSteps })}
        </span>

        {currentStepTitle ? (
          <h5 className="text-sm font-medium text-text-title">
            {currentStepTitle}
          </h5>
        ) : null}
      </div>
    </div>
  );
};
